import React, { useRef } from 'react'
import { Provider } from 'react-redux'
import { Provider as PaperProvider } from 'react-native-paper'
import { NavigationContainer } from '@react-navigation/native'
import * as NavRefHelpers from './src/navigators/NavigationRefHelpers'
import { navigationRef } from './src/navigators/NavigationRefHelpers'
import { setScreen } from './src/analytics'
import InitialScreen from './src/InitialScreen'
import configureStore from './src/configureStore'

const store = configureStore

const linking = {
  prefixes: ['mylatitude://'],
  config: {
    screens: {
      LightStatePage: 'LightStatePage',
      CollectingWavesPage: 'CollectingWavesPage',
      SendingWavesPage: 'SendingWavesPage',
      WhichCallDoctorPage: 'WhichCallDoctorPage',
      WhichYellowWavesPage: 'WhichYellowWavesPage',
      AllGreenButtonPage: 'AllGreenButtonPage',
      FlashingHeartButtonPage: 'FlashingHeartButtonPage',
      LatitudeIndicatorPage: 'LatitudeIndicatorPage',
      NoLightsButtonPage: 'NoLightsButtonPage',
      OneCollectingWavesPage: 'OneCollectingWavesPage',
      OneSendingWavePage: 'OneSendingWavePage',
      RedCallDoctorPage: 'RedCallDoctorPage',
      ThreeCollectingWavesPage: 'ThreeCollectingWavesPage',
      ThreeSendingWavesPage: 'ThreeSendingWavesPage',
      TwoCollectingWavesPage: 'TwoCollectingWavesPage',
      TwoSendingWavesPage: 'TwoSendingWavesPage',
      YellowCallDoctorPage: 'YellowCallDoctorPage',
      BestConnectionPage: 'BestConnectionPage',
      ChooseConnOpPage: 'ChooseConnectionOption',
      WhereToPlaceMonitorPage: 'WhereToPlaceMonitorPage',
      WhatsInMonitorBoxPage: 'WhatsInMonitorBoxPage',
      LandlineSetup1Page: 'LandlineSetup1',
      LandlineSetup2Page: 'LandlineSetup2',
      LandlineSetup3Page: 'LandlineSetup3',
      LandlineSetup4Page: 'LandlineSetup4',
      LandlineSetup5Page: 'LandlineSetup5',
      USBEthernetStep1Page: 'USBEthernetAdapterSetup1',
      USBEthernetStep2Page: 'USBEthernetAdapterSetup2',
      USBEthernetStep3Page: 'USBEthernetAdapterSetup3',
      USBEthernetStep4Page: 'USBEthernetAdapterSetup4',
      USBEthernetStep5Page: 'USBEthernetSetup5',
      USBCellularStep1Page: 'USBCellularAdapterSetup1',
      USBCellularStep2Page: 'USBCellularAdapterSetup2',
      USBCellularStep3Page: 'USBCellularAdapterSetup3',
      USBCellularStep4Page: 'USBCellularAdapterSetup4',
      USBCellularStep5Page: 'USBCellularAdapterSetup5',
    },
  },
}

function App() {
  const routeNameRef = useRef()
  return (
    <PaperProvider>
      <Provider store={store}>
        <NavigationContainer
          linking={linking}
          ref={navigationRef}
          onReady={() => {
            routeNameRef.current = NavRefHelpers.getCurrentRoute()
          }}
          onStateChange={() => {
            const previousRouteName = routeNameRef.current
            const currentRouteName = NavRefHelpers.getCurrentRoute()
            if (previousRouteName !== currentRouteName) {
              setScreen(currentRouteName)
            }
            routeNameRef.current = currentRouteName
          }}
        >
          <InitialScreen />
        </NavigationContainer>
      </Provider>
    </PaperProvider>
  )
}

export default App
